import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faCalendarAlt, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import Internships from "../components/opportunities/internships/internships";
import ProfessionalServices from "../components/opportunities/professionalServices/professionalServices";
import NewViemProjects from "../components/opportunities/projects/projects";
import JobVacancies from "../components/opportunities/jobVacancies/jobVacancies";
import NotOpportunies from "../assets/imgs/no_hay_proyectos.svg";

const ListProject = () => {
    const [filters, setFilters] = useState({
        title: '',
        location: '',
        created: ''
    });

    const [appliedFilters, setAppliedFilters] = useState({
        title: '',
        location: '',
        created: ''
    });

    const initialOpportunityState = {
        internships: [],
        jobVacancies: [],
        professionalServices: [],
        projects: []
    };

    const [opportunities, setOpportunities] = useState(initialOpportunityState);
    const [loading, setLoading] = useState(true);
    const [type_user_session, settype_user_session] = useState(0);
    const cookies = new Cookies();
    const getSesion = cookies.get("Bearer");

    const buildQueryParams = () => {
        const params = new URLSearchParams();

        if (appliedFilters.title) params.append('title', appliedFilters.title);
        if (appliedFilters.location) params.append('location', appliedFilters.location);
        if (appliedFilters.created) params.append('created', appliedFilters.created);

        return params.toString();
    };

    const fetchOpportunities = async () => {
        setLoading(true);
        try {
            const queryParams = buildQueryParams();

            const endpoints = [
                `${process.env.REACT_APP_API_URI}opportunity/search?id_type_opportunity=1&${queryParams}`,
                `${process.env.REACT_APP_API_URI}opportunity/search?id_type_opportunity=2&${queryParams}`,
                `${process.env.REACT_APP_API_URI}opportunity/search?id_type_opportunity=3&${queryParams}`,
                `${process.env.REACT_APP_API_URI}opportunity/search?id_type_opportunity=4&${queryParams}`
            ];

            const [internResp, jobResp, profResp, projResp] = await Promise.all(
                endpoints.map(endpoint => axios.get(endpoint))
            );

            setOpportunities({
                internships: internResp.data.data || [],
                jobVacancies: jobResp.data.data || [],
                professionalServices: profResp.data.data || [],
                projects: projResp.data.data || []
            });

        } catch (error) {
            console.error("Error fetching opportunities:", error);
            setOpportunities(initialOpportunityState);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOpportunities();

        if (getSesion?.type) {
            settype_user_session(getSesion.type);
        }
    }, [appliedFilters]);

    const handleFilterChange = (e: any) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSearch = () => {
        setAppliedFilters(filters);
    };

    return (
        <>
            <section className="block -mt-px md:flex md:flex-wrap">
                <div className="bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple md:w-full lg:w-100% flex justify-center pb-5 lg:py-5 lg:px-10 px-6">
                    <div className="mx-1 lg:mx-8 w-full">
                        <div className="flex flex-wrap justify-center mt-6 mb-8 lg:mt-0">
                            <h1 className="w-full text-Yellow text-center font-bold text-2xl sm:text-3xl">Oportunidades</h1>

                            <div className="w-full mb-6 flex flex-wrap items-end justify-center gap-4 mt-5">
                                <div className="relative flex-1 min-w-[200px] max-w-[300px]">
                                    <label className="block text-sm font-medium text-white mb-1">Título o descripción</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                                        </div>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="Buscar..."
                                            className="pl-10 w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={filters.title}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                </div>

                                <div className="relative flex-1 min-w-[200px] max-w-[300px]">
                                    <label className="block text-sm font-medium text-white mb-1">Ubicación</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-400" />
                                        </div>
                                        <input
                                            type="text"
                                            name="location"
                                            placeholder="Filtrar por ubicación"
                                            className="pl-10 w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            value={filters.location}
                                            onChange={handleFilterChange}
                                        />
                                    </div>
                                </div>

                                <div className="relative flex-1 min-w-[200px] max-w-[300px]">
                                    <label className="block text-sm font-medium text-white mb-1">Fecha</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <FontAwesomeIcon icon={faCalendarAlt} className="text-gray-400" />
                                        </div>
                                        <select
                                            name="created"
                                            className="pl-10 w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none"
                                            value={filters.created}
                                            onChange={handleFilterChange}
                                        >
                                            <option value="">Todas las fechas</option>
                                            <option value="recent">Más recientes</option>
                                            <option value="oldest">Más antiguos</option>
                                            <option value="month">Último mes</option>
                                            <option value="today">Hoy</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="relative flex-1 min-w-[200px] max-w-[300px]">
                                    <label className="block text-sm font-medium text-transparent mb-1">Buscar</label>
                                    <button
                                        onClick={handleSearch}
                                        className="w-full h-[42px] bg-Yellow hover:bg-Yellow-dark text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 flex items-center justify-center"
                                    >
                                        <FontAwesomeIcon icon={faSearch} className="mr-2" />
                                        Buscar
                                    </button>
                                </div>
                            </div>

                            {loading ? (
                                <div className="flex flex-col items-center justify-center py-10">
                                    <div className="w-10 h-10 border-4 border-white border-dashed rounded-full animate-spin"></div>
                                    <p className="text-white mt-4">Cargando oportunidades...</p>
                                </div>
                            ) : (
                                <>
                                    {opportunities.internships.length > 0 && (
                                        <Internships
                                            data={opportunities.internships}
                                            type_user_session={type_user_session}
                                        />
                                    )}

                                    {opportunities.jobVacancies.length > 0 && (
                                        <JobVacancies
                                            data={opportunities.jobVacancies}
                                            type_user_session={type_user_session}
                                        />
                                    )}

                                    {opportunities.professionalServices.length > 0 && (
                                        <ProfessionalServices
                                            data={opportunities.professionalServices}
                                            type_user_session={type_user_session}
                                        />
                                    )}

                                    {opportunities.projects.length > 0 && (
                                        <NewViemProjects
                                            data={opportunities.projects}
                                            type_user_session={type_user_session}
                                        />
                                    )}

                                    {opportunities.internships.length === 0 &&
                                        opportunities.jobVacancies.length === 0 &&
                                        opportunities.professionalServices.length === 0 &&
                                        opportunities.projects.length === 0 && (
                                            <div className="flex flex-col items-center mt-10">
                                                <h5 className="text-white text-center font-bold text-lg sm:text-xl">No se encontraron oportunidades</h5>
                                                <img src={NotOpportunies} className="w-3/5 mt-10" alt="No hay proyectos" />
                                            </div>
                                        )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ListProject;